import {combineReducers} from '@reduxjs/toolkit';
import liveRate from './liverate.slice';
import countrySlice from './countrySlice';

const Slices = combineReducers({
  liveRate: liveRate,
  countryCode: countrySlice,
});
export default Slices;
